import { IntlShape, MessageDescriptor } from 'react-intl';

interface ValidationMessageData {
  $t: IntlShape['$t'];
  message: MessageDescriptor;
  fieldName: MessageDescriptor;
}

export const getFieldRuleValidationMessage = ({
  $t,
  message,
  fieldName,
}: ValidationMessageData) =>
  $t(message, {
    fieldName: $t(fieldName).toLowerCase(),
  });
